import React, { useContext } from "react";
import { StateMachine, State } from "xstate";
import { useMachine } from "@xstate/react";

// We use a generic type to be able to handle
// any shape of context with type checking
interface FunnelProviderProps<TContext> {
  stateMachine: StateMachine<TContext, any, any>;
  children: React.ReactNode;
}

interface FunnelContextValue {
  currentState: State<any>;
  send: (state: string) => void;
}

const FunnelContext = React.createContext({} as FunnelContextValue);

function FunnelProvider({
  stateMachine,
  children,
}: FunnelProviderProps<any>): React.ReactElement {
  const [current, send] = useMachine(stateMachine);
  console.log(current.context);
  return (
    <FunnelContext.Provider value={{ currentState: current, send }}>
      <div>
        <h2> Current Context </h2>
        <h3> Chosen Activity</h3>
        <p> {current.context.activity ?? "Not picked yet"}</p>
        <h3> List of attendees </h3>
        <div>
          {current.context.attendees.length > 0
            ? current.context.attendees.map((member: any) => (
                <p key={member.name}>{`${member.name} ${member.surname}`}</p>
              ))
            : "No attendee added yet"}
        </div>
        <h3> Additional Information </h3>
        <p>
          {current.context.additional_information ?? "No additional info yet"}
        </p>
      </div>
      <hr />
      {children}
    </FunnelContext.Provider>
  );
}

export const useFunnel = () => useContext(FunnelContext);

export default FunnelProvider;
